import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { ReactNode } from 'react';

import { DEVTOOLS_OPTIONS } from '@/modules/debug/constants/zustand';

import { Version } from '../helpers/types';

export interface CanvasOverlayRequest {
  message: ReactNode;
  onCancel?: () => void;
}

export type State = {
  versions: Version[];
  loadingStatus: 'loading' | 'idle';
};

const INITIAL_STATE: State = {
  versions: [],
  loadingStatus: 'idle',
};

type Actions = {
  setVersions(items: State['versions']): void;
  setLoadingStatus(value: State['loadingStatus']): void;
};

export const useVersioningStore = create<State & Actions>()(
  devtools(
    (set) => ({
      ...INITIAL_STATE,

      setVersions(items) {
        set(
          {
            versions: items,
          },
          undefined,
          {
            type: 'versions/set',
          },
        );
      },

      setLoadingStatus(value) {
        set(
          {
            loadingStatus: value,
          },
          undefined,
          {
            type: 'loadingStatus/set',
          },
        );
      },
    }),
    { store: 'versioningStore', ...DEVTOOLS_OPTIONS },
  ),
);
